import Model from './model.js';
import Integrations from 'newCollections/integrations.js';
import axios from 'axios';

export default class Integration extends Model {
    urlRoot() { return '/Integrations'; }

    url() {
        if (this.company && !this.get(this.idAttribute)) {
            return `${this.company.url()}/integrations`;
        }
        return super.url();
    }

    constructor() {
        super(...arguments);
        this.softDelete = true;
    }

    initialize({company = null}) {
        this.idAttribute = 'objectId';
        super.initialize(...arguments);

        this.company = company;
        return this;
    }

    fetchData() {
        return axios.get(this.finalUrl() + '/data', {
            headers: {'Authorization': app.user.getAccessToken().id}
        }).then(r => {
            return r.data.result;
        });
    }

    static fetchIntegration(company) {
        return new Integrations(null, {company})
            .fetch({filter: {
                where: {
                    or: [
                        {expiresAt: {gt: new Date()}},
                        {renewAt: {gt: new Date()}}
                    ],
                    hiddenAt: null
                },
                order: '-createdAt',
                limit: 1
            }})
            .then(collections => collections.at(0));
    }
}



// WEBPACK FOOTER //
// ./app/new-models/integration.js